import { IStore } from '../../../../interfaces/StoreTypes';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationCenter } from '@intigral/ui';
import useLanguage from '../../../../hooks/useLanguage';
import { LanguageToggle } from './LanguageToggle';
import { useMediaQuery } from '@intigral/hooks';
import { useBrazeCards } from '../../../../hooks/useBraze';
import { openSearchInputOverlay } from '../../../../store/reducers/headerSlice';
import { FontIcon } from '@intigral/shared';
import { getUserInfo } from '../../../../utils/user';
import { getFreeTrailCtaUrl, isGuestUser, redirectGuestToSignIn } from '../../../../config/guestMode';
import { Button, Text } from '@intigral/shared';
import { __ } from '../../../../translations';

export const StaticItem = () => {
    const dispatch = useDispatch();
    const { selectedProfile } = useSelector((state: IStore) => state.profile);
    const language = useLanguage();
    const isMobile = useMediaQuery('(max-width: 924px)');
    const brazeCards = useBrazeCards();
    const isGuest = isGuestUser(getUserInfo());

    const handleSearch = (e) => {
        e.preventDefault();
        dispatch(openSearchInputOverlay(true));
        window.setTimeout(() => {
            const querry: any = document?.querySelector('input#head-search-input');
            querry?.focus();
        }, 500);
    };

    if (isGuest) {
        return (
            <>
                {!selectedProfile?.kidsMode && (
                    <>
                        <a onClick={handleSearch}>
                            <FontIcon name="search" size="medium" md="medium" />
                        </a>
                        {!isMobile && (
                            <>
                                <Button
                                    compact
                                    type="button"
                                    onClick={() => {
                                        const href = getFreeTrailCtaUrl();
                                        if (href) {
                                            window.location.assign(href);
                                        }
                                    }}
                                >
                                    <Text as="span" size="18" color="white">
                                        {__('header_guest_start_free_trial')}
                                    </Text>
                                </Button>
                                <Button
                                    compact
                                    headerButton
                                    LinkComponent={'a'}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        redirectGuestToSignIn();
                                    }}
                                >
                                    <Text as="span" color="white">
                                        {__('settings_login')}
                                    </Text>
                                </Button>
                            </>
                        )}
                    </>
                )}
                {isMobile && <LanguageToggle />}
            </>
        );
    }
    return (
        <>
            {!selectedProfile?.kidsMode && (
                <NotificationCenter
                    dir={language === 'ar' ? 'rtl' : 'ltr'}
                    notificationsText="Notifications"
                    siteLogoSrc={'https://web-stg.stctv.com/images/big-logo.svg'}
                    LinkComponent="a"
                    pendingNotificationsCount={brazeCards.length}
                    notificationCards={brazeCards.map((card) => ({
                        imageSrc: card?.imageUrl,
                        title: card?.title,
                        href: card?.url,
                        card: card,
                    }))}
                />
            )}
            <a onClick={handleSearch}>
                <FontIcon name="search" size="medium" md="medium" />
            </a>
            {isMobile && <LanguageToggle />}
        </>
    );
};
